// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"ET-z","inlineTitle":"FT-z","sponsoredAdsWrapper":"GT-z","marketplaceRecosWrapper":"HT-z"};